import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { API_CONFIG } from 'src/app/config/api.config';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token') || '';

    // só adiciona Authorization quando a URL pertence à sua API
    const isApi = req.url.startsWith(API_CONFIG.apiURL);

    // URLs que não devem receber Content-Type JSON (upload/copy/etc.)
    const isMultipartLike =
      req.url.includes('/arquivosfisicos/upload') ||
      req.url.includes('/arquivosfisicos/copyAndPaste') ||
      req.url.includes('/sendMessageWithAttachments');

    let headers: { [name: string]: string | string[] } = {};

    // Authorization
    if (isApi && token) {
      // Se o seu backend espera "Bearer <jwt>", mantenha a linha abaixo.
      // Se ele espera só o token cru, troque para: Authorization: token
      headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }

    // Content-Type:
    // - Não setar para GET/HEAD/DELETE
    // - Não setar para multipart
    // - Deixe o Angular setar application/json automaticamente quando body for objeto
    const hasBody = !!req.body && !['GET', 'HEAD', 'DELETE'].includes(req.method);
    if (hasBody && !isMultipartLike) {
      headers['Content-Type'] = 'application/json';
    }

    // Se precisar enviar cookies de sessão (em vez de Bearer), use withCredentials no próprio request
    // e garanta CORS correto no backend.
    // Ex.: const cloned = req.clone({ withCredentials: true, setHeaders: headers });

    const cloned = req.clone({ setHeaders: headers });

    return next.handle(cloned).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // espaço para tratar headers de resposta se quiser
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {

        //console.log(error);
        console.log('Erro => Ativar console em HttpConfigInterceptor')
        // tratamento básico
        if (error?.status === 401 || error?.status === 403 || error?.error?.status === 401 || error?.error?.status === 403) {
          // opcional: limpar token e redirecionar pro login
          // localStorage.removeItem('token');
          // this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
        }
        return throwError(error);;
      })
    );
  }
}
